import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { Inject } from '@logio/typescript-ioc';
import { jsonConversions, PromoSettingsConverter } from '@logio/common-be-fe';
import { GenericTransportLayer } from '../GenericTransportLayer';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
export var PromoSettingsLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(PromoSettingsLayer, _GenericTransportLaye);

  function PromoSettingsLayer() {
    _classCallCheck(this, PromoSettingsLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoSettingsLayer).call(this, CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS));
  }

  _createClass(PromoSettingsLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Get promo general settings
     * @returns promo settings
     */

  }, {
    key: "getSettings",
    value: function getSettings() {
      var _this = this;

      return api(this.baseUri).get({
        responseType: 'json'
      }).then(function (response) {
        return _this.getConverter().toObject(response.data[0], jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Updates promo general settings
     * @param config
     */

  }, {
    key: "updateSettings",
    value: function updateSettings(config) {
      var _this2 = this;

      return api("".concat(this.baseUri, "/").concat(config.id)).put(this.getConverter().toDocument(config, jsonConversions), {
        responseType: 'json'
      }).then(function (response) {
        return _this2.getConverter().toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return PromoSettingsLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", PromoSettingsConverter)], PromoSettingsLayer.prototype, "converter", void 0);